<script lang="ts" setup>
import { UiBtn } from '@shared/ui';

interface Props {
  error: {
    statusCode: number;
    message: string;
  };
}

defineProps<Props>();
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-4 bg-white p-8 rounded-xl w-full max-w-[562px] max-[444px]:h-full max-[444px]:rounded-none">
    <p class="text-[128px] font-bold leading-tight text-blue-600">
      {{ error.statusCode }}
    </p>
    <h1 class="text-2xl font-bold text-center max-[576px]:text-xl">
      Эта страница только для<br>
      авторизованных пользователей
    </h1>
    <p class="text-center">
      Вам необходимо авторизоваться для доступа к этой странице сайта
    </p>
    <div class="flex gap-3 mt-2">
      <UiBtn
        tag="a"
        href="https://www.4dk.ru/"
        :external="true"
        label="Перейти на главную"
      />
    </div>
  </div>
</template>
